var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInAppNotificationsEmptyStateIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 225,
  height: 179,
  fill: "none",
  viewBox: "0 0 225 179"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#InAppNotificationsEmptyStateIllustration_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#InAppNotificationsEmptyStateIllustration_svg__b)",
  d: "m190.715 55.827-81.401-21.784c-2.456-.915-5.931-.191-7.37 1.255l-80.083 80.795c-.458.462-1.167.707-1.256 1.501-.18 1.615 1.996 4.92 3.585 5.341l83.622 22.173c1.965.521 4.725-.229 6.165-1.676l79.473-80.264c2.132-2.768-.77-6.82-2.735-7.341"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m189.476 55.283-79.934-21.195c-3.203-.85-7.709.352-10.065 2.682L21.73 113.706c-2.356 2.331-1.669 4.909 1.534 5.758l78.002 20.682c4.27 1.133 10.278-.469 13.419-3.576l76.326-75.53c2.355-2.33 1.668-4.908-1.535-5.757"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#InAppNotificationsEmptyStateIllustration_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#InAppNotificationsEmptyStateIllustration_svg__d)",
  d: "m115.306 138.096 76.148-76.714c2.197-2.213 1.673-4.654-1.202-5.602l-3.266-1.078-76.843-20.032c-3.199-.834-7.678.364-10.028 2.682l-77.987 76.922c-2.343 2.31-1.696 4.872 1.45 5.745l78.149 21.684c4.299 1.193 10.431-.436 13.579-3.607"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#InAppNotificationsEmptyStateIllustration_svg__e)",
  d: "m189.476 55.283-79.934-21.195c-3.203-.85-7.709.352-10.065 2.682L21.73 113.706c-2.356 2.331-1.669 4.909 1.534 5.758l78.002 20.682c4.27 1.133 10.278-.469 13.419-3.576l76.326-75.53c2.355-2.33 1.668-4.908-1.535-5.757"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#696992",
  d: "m80.109 89.057-1.624-.43 2.998-5.586-7.072 4.505-1.61-.427 3.84-7.597 1.718.455-3.131 5.788 7.326-4.675 1.421.376-3.104 5.795 7.3-4.682 1.664.441zm12.345.102q-.225.226-.473.423l-5.59-1.481q-.35.593-.08 1.077t1.11.706q.65.173 1.4.122a5 5 0 0 0 1.359-.264l.389.914q-1.034.35-2.135.409a6.5 6.5 0 0 1-2.048-.194q-1.082-.287-1.618-.866-.52-.575-.422-1.31.123-.742.871-1.493.728-.73 1.802-1.208a7.5 7.5 0 0 1 2.247-.59q1.184-.123 2.199.146 1.028.272 1.51.837.48.566.354 1.293-.127.727-.875 1.479m-1.151-.905q.355-.58.115-1.043-.216-.47-.96-.667-.732-.194-1.597-.011a4.35 4.35 0 0 0-1.577.655zm8.572-2.946-7.085 7.111-1.516-.402 7.085-7.111zm-2.127 8.576q-1.041-.276-1.55-.848a1.54 1.54 0 0 1-.381-1.3q.126-.729.864-1.469a5.9 5.9 0 0 1 1.812-1.218 7.6 7.6 0 0 1 2.271-.596 6.3 6.3 0 0 1 2.239.156q1.015.27 1.519.828.505.558.398 1.266l-1.893.235a.92.92 0 0 0-.211-.767q-.28-.338-.876-.495a3.6 3.6 0 0 0-1.303-.083q-.694.078-1.342.368-.624.284-1.058.719-.433.435-.526.871a.92.92 0 0 0 .21.768q.295.34.89.498.596.158 1.289.08a4.6 4.6 0 0 0 1.333-.359l.732.931a7.3 7.3 0 0 1-2.228.57 6.2 6.2 0 0 1-2.189-.155m7.573 2.008q-1.042-.277-1.551-.849a1.54 1.54 0 0 1-.381-1.3q.127-.727.865-1.468a5.9 5.9 0 0 1 1.812-1.218 7.6 7.6 0 0 1 2.27-.597 6.3 6.3 0 0 1 2.239.157q1.03.273 1.523.84.509.573.395 1.304t-.851 1.473q-.738.74-1.825 1.214a7.6 7.6 0 0 1-2.285.593 6.1 6.1 0 0 1-2.211-.15m.489-3.205q-.433.435-.527.872a.92.92 0 0 0 .211.768q.294.34.889.498.596.158 1.29.08a4.3 4.3 0 0 0 1.318-.363 3.6 3.6 0 0 0 1.082-.724q.432-.435.503-.866a.87.87 0 0 0-.187-.774q-.281-.336-.876-.494a3.6 3.6 0 0 0-1.303-.083q-.694.078-1.342.368a3.5 3.5 0 0 0-1.058.718m18.125 1.472q1.177.313 1.359 1.023.192.7-.654 1.55L121.383 100l-1.516-.402 2.932-2.944q.522-.523.408-.94-.091-.425-.795-.61a2.94 2.94 0 0 0-1.516.01 2.75 2.75 0 0 0-1.283.72l-2.912 2.924-1.516-.402 2.932-2.943q.522-.525.407-.941-.09-.424-.794-.61a2.94 2.94 0 0 0-1.516.01 2.75 2.75 0 0 0-1.283.72l-2.913 2.925-1.515-.402 5.018-5.038 1.516.402-.591.593q1.494-.503 2.847-.144.758.2 1.09.588a.98.98 0 0 1 .244.889 5.8 5.8 0 0 1 1.687-.39 4.9 4.9 0 0 1 1.621.143m8.482 5.596a6 6 0 0 1-.473.424l-5.589-1.482q-.353.593-.081 1.077.27.484 1.109.706a4.3 4.3 0 0 0 1.402.122 5.1 5.1 0 0 0 1.358-.264l.388.915q-1.032.35-2.134.408a6.5 6.5 0 0 1-2.048-.194q-1.083-.287-1.618-.866-.522-.575-.422-1.31.123-.742.871-1.493.728-.731 1.802-1.207a7.5 7.5 0 0 1 2.247-.59q1.183-.124 2.199.145 1.027.273 1.509.837.481.565.355 1.293-.127.728-.875 1.479m-1.151-.905q.355-.58.115-1.043-.216-.47-.961-.667-.73-.195-1.597-.011a4.4 4.4 0 0 0-1.577.655z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "m222.672 93.518 1.951-1.987c.137-.139.24-.3.304-.474a1.224 1.224 0 0 0-.114-1.059 1.4 1.4 0 0 0-.399-.418l-9.902-6.954a1.75 1.75 0 0 0-1.141-.3 1.67 1.67 0 0 0-1.058.477l-1.549 1.578a1.26 1.26 0 0 0-.373.981c.028.357.216.69.523.929l9.504 7.361c.157.122.34.215.539.274a1.8 1.8 0 0 0 1.224-.073c.188-.082.355-.196.491-.335"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "m222.064 90.341 1.4-1.425-8.954-6.288a1.75 1.75 0 0 0-1.141-.3c-.411.034-.79.204-1.058.477l-1.037 1.058 8.535 6.611c.157.122.341.215.54.275a1.8 1.8 0 0 0 1.223-.073c.188-.082.356-.196.492-.335"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "m150.921 28.676-2.325-.626a1.46 1.46 0 0 0-.987.084c-.15.07-.282.166-.388.281a1.05 1.05 0 0 0-.232.39l-.27.824-2.547 7.774a.98.98 0 0 0 .106.83c.159.255.426.445.744.531l1.238.333.609.164c.319.086.664.06.961-.071.297-.132.523-.36.63-.633l3.293-8.47a.97.97 0 0 0-.073-.857 1.15 1.15 0 0 0-.315-.343 1.3 1.3 0 0 0-.444-.21"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "m148.385 30.078-1.666-.45-2.547 7.775a.98.98 0 0 0 .106.83c.159.255.426.445.744.531l1.238.333 2.957-7.608a.97.97 0 0 0-.073-.858 1.1 1.1 0 0 0-.315-.343 1.3 1.3 0 0 0-.444-.21"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "M145.145 57.114a2.17 2.17 0 0 0-.723-1.14 2.74 2.74 0 0 0-1.333-.601 2.95 2.95 0 0 0-1.492.142 2.53 2.53 0 0 0-1.15.838 2.03 2.03 0 0 0-.419 1.25c.005.444.163.876.452 1.242s.697.649 1.172.814a2.96 2.96 0 0 0 2.028-.04c.537-.21.975-.573 1.242-1.028.266-.456.345-.977.223-1.477"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "M143.874 58.098c-.147-.606-.555-1.14-1.133-1.481a2.85 2.85 0 0 0-2.479-.19c-.213.39-.299.83-.247 1.266s.238.854.539 1.203.703.617 1.161.772.953.191 1.428.104a2.6 2.6 0 0 0 .53-.154 2.1 2.1 0 0 0 .201-1.52"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "M185.096 79.666a2.17 2.17 0 0 0-.723-1.14 2.74 2.74 0 0 0-1.333-.601 2.95 2.95 0 0 0-1.492.142 2.53 2.53 0 0 0-1.15.838 2.03 2.03 0 0 0-.419 1.25c.006.444.163.876.452 1.242.289.365.697.649 1.172.814a2.96 2.96 0 0 0 2.028-.04c.537-.21.975-.573 1.242-1.028s.345-.977.223-1.477"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "M183.825 80.65c-.147-.606-.555-1.14-1.133-1.481a2.85 2.85 0 0 0-2.479-.19c-.213.39-.299.83-.247 1.266s.238.854.539 1.203.703.617 1.161.772.953.191 1.428.104q.275-.05.53-.154a2.1 2.1 0 0 0 .201-1.52"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#8296FF",
  d: "m198.361 40.668 4.749 1.706a3.8 3.8 0 0 1 1.416.895c.384.392.655.857.79 1.357.136.5.133 1.02-.01 1.52-.142.498-.419.96-.808 1.348-.51.51-1.192.867-1.949 1.025a4.3 4.3 0 0 1-2.274-.148l-14.798-5.198 3.656-1.995zM159.636 67.803l-4.749-1.706a3.75 3.75 0 0 1-1.416-.895 3.1 3.1 0 0 1-.791-1.357 2.83 2.83 0 0 1 .01-1.52c.143-.498.42-.96.808-1.348a3.87 3.87 0 0 1 1.95-1.025 4.3 4.3 0 0 1 2.274.148l14.798 5.197-3.656 1.996z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#DAE0FF",
  d: "M159.636 67.803c4.012 1.558 7.806 2.316 11.036 2.247 0 0 9.792.28 13.845-14.693 4.054-14.97 13.844-14.69 13.844-14.69-4.012-1.557-7.806-2.315-11.034-2.245 0 0-9.792-.281-13.845 14.692-4.054 14.97-13.846 14.69-13.846 14.69"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "m30.362 87.613-1.56-1.595a1.1 1.1 0 0 1-.243-.381.97.97 0 0 1 .09-.85q.121-.197.32-.336l7.922-5.585a1.4 1.4 0 0 1 .912-.24c.329.026.633.164.847.382l1.239 1.268c.213.218.32.501.298.788a1.05 1.05 0 0 1-.418.745l-7.603 5.912a1.3 1.3 0 0 1-.432.22 1.44 1.44 0 0 1-.979-.059 1.3 1.3 0 0 1-.393-.27"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "m30.849 85.062-1.12-1.145 7.163-5.05c.257-.18.584-.266.913-.24.328.027.632.164.846.383l.83.85-6.828 5.309a1.3 1.3 0 0 1-.432.22 1.44 1.44 0 0 1-.979-.058 1.3 1.3 0 0 1-.393-.27"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "m87.763 35.543 1.86-.503a1.17 1.17 0 0 1 .79.067q.181.087.31.226a.85.85 0 0 1 .186.314l.216.661 2.038 6.243a.79.79 0 0 1-.085.667 1 1 0 0 1-.596.426l-.99.267-.487.132c-.255.069-.531.048-.769-.057a.94.94 0 0 1-.504-.509l-2.635-6.8a.78.78 0 0 1 .059-.69.9.9 0 0 1 .252-.275c.104-.076.225-.134.355-.169"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "m89.792 36.668 1.333-.36 2.038 6.243a.79.79 0 0 1-.085.667 1 1 0 0 1-.596.426l-.99.267-2.366-6.109a.79.79 0 0 1 .059-.689.9.9 0 0 1 .252-.276q.158-.115.355-.169"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "M92.384 58.38a1.75 1.75 0 0 1 .579-.917 2.2 2.2 0 0 1 1.066-.482 2.36 2.36 0 0 1 1.194.115c.376.14.696.374.92.672.223.299.34.648.335 1.004s-.13.703-.362.997a2.04 2.04 0 0 1-.938.654 2.36 2.36 0 0 1-1.622-.032c-.43-.168-.78-.46-.993-.826a1.6 1.6 0 0 1-.18-1.185"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "M93.4 59.17c.119-.487.445-.915.907-1.19a2.27 2.27 0 0 1 1.984-.153c.17.314.239.667.197 1.017-.041.351-.19.686-.431.967a2.1 2.1 0 0 1-.93.62 2.3 2.3 0 0 1-1.141.083 2 2 0 0 1-.424-.123 1.7 1.7 0 0 1-.161-1.221"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#56D0B5",
  d: "M60.423 76.49a1.75 1.75 0 0 1 .579-.917 2.2 2.2 0 0 1 1.066-.482 2.36 2.36 0 0 1 1.194.115c.376.14.696.374.92.672.223.299.34.648.335 1.004s-.13.703-.362.997a2.04 2.04 0 0 1-.937.654 2.36 2.36 0 0 1-1.623-.032c-.43-.169-.78-.46-.993-.826a1.6 1.6 0 0 1-.179-1.186"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#73F9C3",
  d: "M61.44 77.28c.118-.487.444-.915.906-1.19a2.27 2.27 0 0 1 1.984-.153c.17.314.239.667.197 1.017-.041.351-.19.686-.431.967-.24.28-.563.495-.929.62a2.3 2.3 0 0 1-1.142.083 2 2 0 0 1-.424-.124 1.7 1.7 0 0 1-.161-1.22"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#8296FF",
  d: "m49.811 45.172-3.799 1.37a3 3 0 0 0-1.133.72 2.5 2.5 0 0 0-.632 1.089c-.109.401-.106.82.008 1.22s.335.772.646 1.083c.409.41.954.697 1.56.823a3.4 3.4 0 0 0 1.82-.119l11.837-4.173-2.925-1.602zM80.791 66.963l3.8-1.37a3 3 0 0 0 1.132-.719c.307-.314.524-.688.633-1.09.108-.4.105-.82-.008-1.22a2.5 2.5 0 0 0-.647-1.083 3.1 3.1 0 0 0-1.56-.823 3.4 3.4 0 0 0-1.819.12L70.484 64.95l2.925 1.602z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#DAE0FF",
  d: "M80.791 66.963c-3.21 1.251-6.245 1.86-8.829 1.804 0 0-7.833.226-11.075-11.798C57.643 44.947 49.81 45.172 49.81 45.172c3.21-1.25 6.245-1.86 8.828-1.803 0 0 7.833-.225 11.075 11.798 3.244 12.022 11.077 11.796 11.077 11.796"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "InAppNotificationsEmptyStateIllustration_svg__b",
  x1: 195.27,
  x2: 12.061,
  y1: 53.443,
  y2: 8.774,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8B98DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#C1CBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.304,
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.333,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492,
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.857,
  stopColor: "#94A0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAE0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "InAppNotificationsEmptyStateIllustration_svg__d",
  x1: 195.967,
  x2: -151.4,
  y1: 49.493,
  y2: 503.872,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "InAppNotificationsEmptyStateIllustration_svg__e",
  x1: 195.348,
  x2: -152.019,
  y1: 48.88,
  y2: 503.259,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "InAppNotificationsEmptyStateIllustration_svg__a",
  width: 213.604,
  height: 169.636,
  x: 0.595,
  y: 3.637,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_108_2468"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_108_2468",
  result: "effect2_dropShadow_108_2468"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_108_2468",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "InAppNotificationsEmptyStateIllustration_svg__c",
  width: 174.09,
  height: 109.69,
  x: 19.72,
  y: 33.405,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_108_2468",
  stdDeviation: 0.5
})))));
export default SvgInAppNotificationsEmptyStateIllustration;